export enum CommunicationStateEnum {
  Created = 'Created',
  Draft = 'Draft',
  Planned = 'Planned',
  Published = 'Published',
  Archived = 'Archived'
}
